<app-wizard-bar-nav [stepIsDirty]="this.isQuoteRequestInvalidated()"></app-wizard-bar-nav>
<div class="step-container">
  <h3>Usage Data | <em heading-info [quoteInfo]="quoteRequestState"></em></h3>
  <p *ngIf="!isReadOnly">
    Don't have a Custom Usage data file?
    <a *ngIf="!isGasQuote()" href="../../../../assets/csvs/custom-electricity-usage-template.csv"
      >Download a Custom Electricity Usage data file template</a
    >
    <a *ngIf="isGasQuote()" href="../../../../assets/csvs/custom-gas-usage-template.csv">Download a Custom Gas Usage data file template</a>
  </p>
  <app-apply-to-all [dataSource]="dataSource"></app-apply-to-all>
  <div class="upload-status">
    <app-upload
      id="consumption-upload"
      [waitForConfirmationFunc]="resolveWaitForUploadConfirmation"
      (after-closed)="onCompleteUpload($event)"
      (on-error)="onUploadError($event)"
      (on-upload-start)="parsingErrorMessages = []"
      [fileTypes]="['csv', 'xlsx']"
      [upload-url]="'file/parse'"
      [additionalData]="parseRequestData"
      [document-type]="'ConsumptionData'"
      [ignoreUnsupportedFileDialog]="true"
      [upload-description]="'Drag and drop your usage data files here'"
      [disabled]="isReadOnly"
    ></app-upload>
    <div class="upload-status-box">
      <p [ngStyle]="{ color: validMeterCount === 0 ? '#F28E29' : '#009E0F' }">
        <img
          [src]="validMeterCount === 0 ? '../../../../assets/icons/icon_warning.svg' : '../../../../assets/icons/icon_success.svg'"
          class="icon-sm"
          aria-hidden="false"
          aria-label="Missing data files"
        />
        {{ validMeterCount }} / {{ meterCount }} files completed
      </p>
      <p *ngIf="validMeterCount === 0 || validMeterCount / meterCount < 1" [ngStyle]="{ color: '#F28E29' }">
        <img src="../../../../assets/icons/icon_warning.svg" class="icon-sm" aria-hidden="false" aria-label="Missing data files" />
        {{ outstandingRequestedDataCount }} / {{ meterCount }} files requested
      </p>
      <p style="color: red" *ngFor="let errMessage of getParsingErrorMessages()">
        <img src="../../../../assets/icons/icon_error.svg" class="icon-sm" aria-hidden="false" aria-label="Parsing error" />
        {{ errMessage }}
      </p>
      <p style="color: red" *ngIf="getParsingErrorMessages()?.length">
        Please correct any errors in the above files and re-upload to continue
      </p>
    </div>
  </div>

  <div class="flex-end">
    <button
      *ngIf="meterVaultEnabled"
      id="requestDataBtn"
      mat-stroked-button
      color="accent"
      type="button"
      [disabled]="isRequestDataBtnDisabledForAll() || isReadOnly"
      (click)="requestConsumptionDataForAllAccounts()"
    >
      <mat-icon color="accent" matPrefix>send</mat-icon> Request Usage Data for All
    </button>
  </div>

  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="utilityAccountNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Utility Account Number</th>
      <td mat-cell *matCellDef="let uan">
        {{ uan.utilityAccountNumber }}
      </td>
    </ng-container>

    <ng-container matColumnDef="rateCode">
      <th mat-header-cell *matHeaderCellDef>Load Profile</th>
      <td mat-cell *matCellDef="let rateCode; let i = index">
        <select
          id="rateCode"
          (change)="rateCodeChanged($event, rateCode)"
          [class.invalid]="isRateCodeInvalid(rateCode)"
          [disabled]="isRateCodeDisabled(i) || isReadOnly"
        >
          <option selected *ngIf="fetchingRateCodes">Loading..</option>
          <option value="">-- Please Select --</option>
          <option *ngFor="let rc of findRateCodes(this.dataSource.data[i].utilityDetails.utilityShort)" [selected]="isSelected(rc, i)">
            {{ rc.rateCode }}
          </option>
        </select>
      </td>
    </ng-container>

    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>File Name</th>
      <td mat-cell *matCellDef="let uan">
        <p *ngIf="uan.consumptionData.source === 'File'">
          <a appDownloadLink [file]="uan.consumptionData.dataFile">{{ uan.consumptionData?.dataFile?.fileName }}</a>
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="dateRequested">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Requested</th>
      <td mat-cell *matCellDef="let uan">
        <p>{{ uan.consumptionData.dateRequested | date: dateFormat }}</p>
      </td>
    </ng-container>

    <ng-container matColumnDef="lastModified">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Modified</th>
      <td mat-cell *matCellDef="let uan">
        <p>{{ uan.consumptionData.lastModified | date: dateFormat }}</p>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let uan">
        <p *ngIf="uan.consumptionData.consumptionDataReceived && uan.consumptionData.source !== 'File'; else elseBlock">
          <img
            [ngStyle]="{ color: '#009E0F' }"
            src="../../../../assets/icons/icon_success.svg"
            class="icon-sm"
            aria-hidden="false"
            aria-label="Usage received"
          />
          Usage Received
        </p>
        <ng-template #elseBlock>
          <p *ngIf="uan.consumptionData.consumptionDataRequested">
            <img
              [ngStyle]="{ color: '#F28E29' }"
              src="../../../../assets/icons/icon_warning.svg"
              class="icon-sm"
              aria-hidden="false"
              aria-label="Usage requested"
            />
            Usage Requested
          </p>
          <p *ngIf="uan.consumptionData.consumptionDataRequestedErrored && uan.consumptionData.source !== 'File'">
            <img
              [ngStyle]="{ color: '#FF0000' }"
              src="../../../../assets/icons/icon_warning.svg"
              class="icon-sm"
              aria-hidden="false"
              aria-label="Usage requested"
            />
            Usage Could Not Be Found
          </p>
          <p *ngIf="uan.consumptionData.source === 'File'">
            <img
              [ngStyle]="{ color: '#009E0F' }"
              src="../../../../assets/icons/icon_success.svg"
              class="icon-sm"
              aria-hidden="false"
              aria-label="Uploaded usage"
            />
            Usage Uploaded
          </p>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="remove">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let uan">
        <div class="delete-container" *ngIf="uan.consumptionData.source === 'File'">
          <app-delete-file
            class="delete-container-item"
            [file]="uan.consumptionData.dataFile"
            [buttonText]="'Delete File'"
            [quoteRequestId]="quoteRequestId"
            (after-delete)="onDeleteConsumptionDataUpload($event)"
            [disabled]="isReadOnly"
          >
          </app-delete-file>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="requestConsumptionData">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let uan">
        <div class="delete-container">
          <button
            *ngIf="meterVaultEnabled"
            id="requestDataBtn"
            mat-stroked-button
            color="accent"
            type="button"
            (click)="requestConsumptionDataForSingleAccount(uan)"
            [disabled]="isRequestDataBtnDisabledForOne(uan) || isReadOnly"
          >
            <mat-icon color="accent" matPrefix>send</mat-icon> Request Usage Data
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns"></tr>
  </table>
</div>

<app-wizard-step-nav-buttons (backClicked)="back()" (nextClicked)="next()"></app-wizard-step-nav-buttons>
